module.exports = __webpack_public_path__ + "img/8.52f2f697.jpg";